import { useNavigate } from "react-router-dom";
import "./brand.styles.scss";
const Brand = () => {
  const navigate = useNavigate();
  return (
    <div className="brand-emblem">
      <span className="brand-emblem-symbol" onClick={() => navigate("/home")}>
        W
      </span>
    </div>
  );
};
export default Brand;
